<h3 class="mr-3">Title insurance</h3>
<app-mms-mortgage-warning></app-mms-mortgage-warning>
<div class="flex justify-center mb-10">
	<div class="flex flex-col items-center">
		<div class="flex w-32 h-32">
			<img src="/assets/images/integrations/chicago-title-logo.svg" />
		</div>
		<span
			*ngIf="
				(status === ChicagoStatus.NOT_SUBMITTED ||
					status === ChicagoStatus.CANCELLED ||
					!status) &&
				!loading
			"
			class="text-sm text-green underline cursor-pointer mb-3"
			(click)="selectInsuranceProvider()"
			[testHook]="testHooks.SelectInsuranceProviderSpan"
			>Switch provider</span
		>
		<app-title-insurance-toolbar
			[provider]="titleInsurance?.provider"
			[orderValid]="orderValid"
			[status]="status"
			(cancelOrder)="cancel()"
			(openModal)="openPortal()"
		></app-title-insurance-toolbar>
		<app-missing-fields-notif
			*ngIf="status && !orderValid && !isCommercial"
			[missing]="missing"
		></app-missing-fields-notif>
	</div>
</div>

<div class="flex gap-2 items-center justify-between mt-1">
	<hr class="w-5/12 mt-2" />
	<p class="text-lg font-bold text-center">Order summary</p>
	<hr class="w-5/12 mt-2" />
</div>

<div
	*ngIf="status && status !== ChicagoStatus.NOT_SUBMITTED"
	class="flex gap-2 justify-center items-center mt-3"
>
	<div class="border-r border-grey-veryLight pr-2">
		<p>
			<span class="text-gray">Order number: </span>
			<span class="font-bold"> {{ titleInsurance?.thirdPartyId }} </span>
		</p>
	</div>
	<div
		class="border-r border-grey-veryLight pr-2"
		*ngIf="titleInsurance?.orderedOn"
	>
		<p>
			<span class="text-gray">Order date: </span>
			<span class="font-bold">
				{{ titleInsurance?.orderedOn | date: 'mediumDate' }}
			</span>
		</p>
	</div>
	<div *ngIf="effectiveDate$ | async">
		<p>
			<span class="text-gray">Effective date: </span>
			<span class="font-bold">
				{{ effectiveDate$ | async | date: 'mediumDate' }}
			</span>
		</p>
	</div>
</div>

<div
	*ngIf="status !== ChicagoStatus.READY_FOR_PICKUP"
	class="flex mt-10 justify-center mx-4"
>
	<app-step-progress-nav
		class="stepper"
		[steps]="steps"
		[current]="currentStep"
		[testHook]="testHooks.StepProgressNav"
	></app-step-progress-nav>
</div>

<div *ngIf="loading" class="flex flex-1 flex-col justify-center items-center">
	<div class="mt-10 flex items-center">
		<app-icon
			[icon]="ICON.LOADING"
			class="text-7xl mr-3 text-grey"
			[spin]="true"
		></app-icon>
		<h4 class="text-grey">
			<span>Loading</span>
		</h4>
	</div>
</div>

<div *ngIf="!loading">
	<app-chicago-not-submitted
		*ngIf="!status || status === ChicagoStatus.NOT_SUBMITTED"
		[missing]="missing"
		[orderValid]="orderValid"
		[isCommercial]="isCommercial"
		[outOfOntario]="outOfOntario"
		[showPriorityWarning]="showPriorityWarning"
	></app-chicago-not-submitted>
	<app-chicago-under-review
		*ngIf="
			status === ChicagoStatus.UNDER_REVIEW ||
			status === ChicagoStatus.WAITING_FOR_INFORMATION
		"
		[matterId]="matterId"
		[thirdPartyId]="thirdPartyId"
		[status]="status"
	></app-chicago-under-review>
	<app-chicago-ready-for-pickup
		*ngIf="status === ChicagoStatus.READY_FOR_PICKUP"
		[status]="status"
		[matterId]="matterId"
		[thirdPartyId]="thirdPartyId"
	></app-chicago-ready-for-pickup>
	<app-chicago-cancelled
		*ngIf="status === ChicagoStatus.CANCELLED"
	></app-chicago-cancelled>
</div>
